import React, { useState, forwardRef } from "react";
import Classes from "./styles/style.module.css";
import PlayIcon from "../../assets/images/icons/playIcon.svg";
import {
  convertToShamsiTime,
  convertToShamsi,
} from "../../assets/utils/ConvertToShamsi";
import VideoPlayer from "../../assets/components/VideoPlayer";
import BlogSlider from "./BlogSlider";
import { MdOutlineRemoveRedEye } from "react-icons/md";

const BlogListElement = forwardRef(({ data, dark, purpleDark }, ref) => {

  const [isOpen, setIsOpen] = useState(false);

  const handleVideoClick = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const handleClick = (e) => {
    if (data.link) {
      if (data.linkNewTab) {
        window.open(data.link, "_blank");
      } else {
        window.location.href = data.link;
      }
    }
  };

  const getTopSection = (list) => {
    if (list.length !== 0) {
      return <BlogSlider data={list} dark={dark} />;
    } else {
      if (data.image && !data.video) {
        return <img src={data.image} alt="blogImg" />;
      } else if (data.video) {
        return (
          <>
            <img src={data.image} alt="blogImg" />
            <div className={Classes.videoBG} onClick={handleVideoClick}></div>
            <div
              className={Classes.videButtonContainer}
              onClick={handleVideoClick}
            >
              <img src={PlayIcon} alt="playIcon" className={Classes.playIcon} />
            </div>
          </>
        );
      }
    }
  };

  return (
    <>
      <div
        className={`${Classes.blogListElementConatiner} ${
          dark ? Classes.dark : ""
        }
         ${purpleDark ? Classes.purpleDark : ""}
        `}
        onClick={handleClick}
        ref={ref}
      >
        {data.image || data.video || data.mediaList.length !== 0 ? (
          <div className={Classes.blogMediaContainer}>
            {getTopSection(data.mediaList.slice().reverse())}
          </div>
        ) : null}
        <div className={Classes.blogContentContainer}>
          <p className={Classes.blogTitle}>{data.title}</p>
          <p
            className={Classes.blogDescription}
            dangerouslySetInnerHTML={{ __html: data.description }}
          ></p>
        </div>
        <div className={Classes.dateContainer}>
          <div className="d-flex align-items-center">
            <p>{convertToShamsiTime(data.createdAt)}</p>
            <div className="mr-3 d-flex ">
            <MdOutlineRemoveRedEye />
            <p className="mr-2">{+data.getCount + 100 - +data.getCount%100}</p>
            </div>
          </div>
          <p>{convertToShamsi(data.createdAt)}</p>
        </div>
      </div>
      <VideoPlayer
        open={isOpen}
        closeHandler={() => setIsOpen(false)}
        videoUrl={data.video}
      />
    </>
  );
});

export default BlogListElement;
